// extracted by mini-css-extract-plugin
export var darkMode = "_14-0";